import type { VariantProps } from "class-variance-authority"
import { cva } from "class-variance-authority"

export { default as Button } from "./Button.vue"

export const buttonVariants = cva(
  "inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        // Primary brand button — Muted Moss (#6C7C6A). Replaces black as the default.
        default: "bg-moss text-moss-foreground hover:bg-moss/90",
        moss: "bg-moss text-moss-foreground hover:bg-moss/90",
        black: "bg-black text-white hover:bg-black/90",
        destructive:
          "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        "destructive-gradient":
          "bg-gradient-to-r from-red-700 via-red-500 to-red-700 [background-size:200%_auto] [transition:background-position_0.5s_ease] text-white border-0 hover:[background-position:99%_center] focus-visible:ring-red-500/30",
        // Secondary outline/ghost — warm taupe (#E9E4DE) hover to match the brand palette.
        outline:
          "border border-input bg-background hover:bg-[#E9E4DE]",
        secondary:
          "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        ghost: "hover:bg-[#E9E4DE]",
        link: "text-primary underline-offset-4 hover:underline",
        overlay: "bg-transparent text-white/70 hover:bg-white/[0.08] hover:text-white",
      },
      size: {
        "default": "h-10 px-4 py-2",
        "xs": "h-7 rounded-md px-2.5 text-xs",
        "sm": "h-9 rounded-md px-3",
        "lg": "h-11 rounded-md px-8",
        "icon": "h-10 w-10",
        "icon-xs": "size-7",
        "icon-sm": "size-9",
        "icon-lg": "size-11",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
)

export type ButtonVariants = VariantProps<typeof buttonVariants>
